import { createContext } from 'react';
import type { Dispatch, RefObject, SetStateAction } from 'react';

import type { AutopilotInfo, FeedProps } from './Feed.types';

export interface FeedContextValue
  extends Pick<
    FeedProps,
    | 'searchTypes'
    | 'searchResults'
    | 'userInfo'
    | 'interactionRenderers'
    | 'markdownMap'
    | 'onAutopilotClick'
    | 'onMentionClick'
    | 'onMentionPreview'
    | 'onTagClick'
    | 'onLinkRender'
  > {
  autopilotInfo: AutopilotInfo;
  onSearch?: FeedProps['onDecoratorSearch'];
  showSearchResults?: boolean;
  setShowSearchResults?: Dispatch<SetStateAction<boolean>>;
  feedRef?: RefObject<HTMLDivElement>;
}

export const FeedContext = createContext<FeedContextValue>({
  searchTypes: [],
  autopilotInfo: {
    id: 'autopilot',
    label: 'Autopilot'
  },
  userInfo: { username: '', fullname: '' }
});
